import React from 'react';

const BusinessInfo = ({ userData, handleInputChange }) => {
  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-abiu-green-dark mb-4">About Business</h2>
      
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <h3 className="font-semibold text-gray-800 mb-3">Business Information</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Account Type</label>
              <div className={`inline-flex items-center px-4 py-2 rounded-lg text-sm font-bold ${
                userData.userType === 'buyer' 
                  ? 'bg-blue-100 text-blue-800 border-2 border-blue-300' 
                  : 'bg-green-100 text-green-800 border-2 border-green-300'
              }`}>
                <span className="mr-2">
                  {userData.userType === 'buyer' ? '🛒' : '🏢'}
                </span>
                {userData.userType === 'buyer' ? 'BUYER' : 'SELLER'}
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
              <input 
                type="text" 
                value={userData.name}
                onChange={(e) => handleInputChange('name', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Business Name</label>
              <input 
                type="text" 
                value={userData.business}
                onChange={(e) => handleInputChange('business', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Contact Email</label>
              <input 
                type="email" 
                value={userData.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
              <input 
                type="text" 
                value={userData.location}
                onChange={(e) => handleInputChange('location', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
              <input 
                type="tel" 
                value={userData.phone}
                onChange={(e) => handleInputChange('phone', e.target.value)}
                placeholder="+234 801 234 5678"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
              />
            </div>
          </div>
        </div>

        <div>
          <h3 className="font-semibold text-gray-800 mb-3">Business Details</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Business Description</label>
              <textarea 
                rows="4"
                value={userData.businessDescription}
                onChange={(e) => handleInputChange('businessDescription', e.target.value)}
                placeholder="Describe your business and services..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Specializations</label>
              <input 
                type="text" 
                value={userData.specializations}
                onChange={(e) => handleInputChange('specializations', e.target.value)}
                placeholder="e.g., Residential Solar, Commercial Installations"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Years in Business</label>
              <input 
                type="number" 
                value={userData.yearsInBusiness}
                onChange={(e) => handleInputChange('yearsInBusiness', e.target.value)}
                placeholder="5"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Online Presence Section */}
      <div className="mt-6">
        <h3 className="font-semibold text-gray-800 mb-3">Online Presence</h3>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Website</label>
            <input 
              type="url" 
              value={userData.website}
              onChange={(e) => handleInputChange('website', e.target.value)}
              placeholder="https://yourwebsite.com"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Facebook Page</label>
            <input 
              type="text" 
              value={userData.facebook}
              onChange={(e) => handleInputChange('facebook', e.target.value)}
              placeholder="Your Facebook page or profile"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Instagram Handle</label>
            <input 
              type="text" 
              value={userData.instagram}
              onChange={(e) => handleInputChange('instagram', e.target.value)}
              placeholder="@yourinstagram"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-abiu-green"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessInfo; 